import ProductPricing from './ProductPricing'

export default ProductPricing
